import React, { useEffect, useState } from 'react';
import { Select } from '@cimpress/react-components';
import { StoreState } from '../store/state';
import { Location } from '../models/location';
import { connect } from 'react-redux';
import { nameOf } from '../common/utils';
import { withRouter } from 'react-router-dom';
import { setCurrentLocation } from '../store/actions/location';
import { getLocations } from './locationsActions';
import { toast } from '../store/actions/toast';
import { ToastType } from '../models/utils';
import { valueToArray } from '../utils/functions';

interface Props {
  selectedLocation: Location;
  setLocation: (location: Location) => void;
  showError: (err: any) => void;
}

function locationToOption(location: Location) {
  return { label: location.name, value: location.key };
}

// tslint:disable-next-line:variable-name
const SelectLocation = ({ selectedLocation, setLocation, showError }: Props) => {
  const [locations, setLocations] = useState<Location[]>([]);
  const fetchLocations = async () => {
    try {
      const data = await getLocations();
      setLocations(data);
    } catch (err) {
      showError(err);
    }
  };

  useEffect(() => { fetchLocations(); }, []);

  return <Select
    label="Select a location"
    value={locationToOption(selectedLocation)}
    options={locations.map(locationToOption)}
    onChange={option => {
      if (option) {
        setLocation(locations.find(l => l.key === valueToArray(option)[0].value)!);
        window.location.href = '/';
      }
    }}
    tether
    labelKey={nameOf<Location>('name')}
  />;
};

const mapStateToProps = (state: StoreState) => ({
  selectedLocation: state.location,
});

const mapDispatchToProps = {
  setLocation: setCurrentLocation.request,
  showError: (err: Error) => toast.push({
    type: ToastType.DANGER,
    message: 'An error occured',
    details: err.message,
    links: [],
  }),
};

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  )(SelectLocation) as any,
);
